import type { TableCell } from '../model/form.types';

export function isCoveredCell(cell: TableCell): boolean {
  return cell.isMerged === true || cell.rowSpan === 0 || cell.colSpan === 0;
}
